module.exports = __webpack_public_path__ + "static/img/bg-en.152018d8.png";